module.exports = __webpack_public_path__ + "img/new_list.c7d8a5a9.svg";